import React, { useEffect, useRef, useState } from 'react';
import InputField from '../../../../component/form/FormInput';
import ImageUpload from '../../../../component/uplaodImage';
import Checkbox from '../../../../component/checkbox';
import InputSelect from '../../../../component/inputSelect/InputSelect';
import Modal from '../../../../component/modal/Modal';
import AddProductGroup from '../productGroup/AddProductGroup';
import { useDispatch, useSelector } from 'react-redux';
import { useBlocker, useLocation, useNavigate, useParams } from 'react-router-dom';
import ProductCatogery from '../productCatogery/ProductCatogery';
import { ObjectCreate } from '../../../../utils/utility';
import { product_group_list } from '../../../../store/action/group';
import Addshelf from '../shelf/Shelf';
import { product_catogery_list } from '../../../../store/action/catogery';
import { shelf_list } from '../../../../store/action/shelf';
import { master_data } from '../../../../store/action/master';
import { HSN_list } from '../../../../store/action/utility';
import Button from '../../../../component/ui/Button';
import AddProductTable from './AddProductTable';
import tooltipIcon from '../../../../assets/image/tooltip_vendor name.png';
import {
	change_status,
	createProductBatch,
	product_Update,
	product_code_get,
	product_create,
	updateProductBatch,
} from '../../../../store/action/product';
import { toast } from 'react-toastify';
import BulkImport from '../BulkImport';
import ModalRight from '../../../../component/modalRight';
import { formatErrors, hasPermission } from '../../../../utils/controller';
import CreateGroupCodeModel from '../productGroup/createGroupCodeModel';
import { getDate } from '../../../../utils/dateUtils';
import {
	createDraftProduct,
	deleteBatch,
	deleteDraftProduct,
	getDraftProductList,
	getProductDetails,
	publishDraftProduct,
	updateDraftProduct,
} from '../../../../services/products';
import {
	getMeasuringUnitGeneral,
	getPackagingGeneral,
} from '../../../../services/settings/inventory';
import { getTaxRates } from '../../../../services/settings/organization';
import AddMeasuringUnitModel from '../../../components/addMeasuringUnitModel';
import AddPackagingModel from '../../../components/addPackagingModel';
import DeleteModal from '../../../v2/components/deleteModal';
import AutoSaveModal from '../../../components/autoSaveModal';

const CreateProduct = () => {
	const suburl = localStorage.getItem('suburl');
	const param = useParams();
	const location = useLocation();
	const productID = param?.id;
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const [isPackagingFocus, setPackagingFocus] = useState(false);
	const [errorCells, setErrorCells] = useState([]);
	const [isNextLocation, setIsNextLocation] = useState(null);
	const [isLocationBlocker, setIsLocationBlocker] = useState(true);
	const [isProductAutoSave, setIsProductAutoSave] = useState(false);
	const [isOpenGroupCodeModel, setIsOpenGroupCodeModel] = useState(false);
	const [isMeasuringUnitFocus, setMeasuringUnitFocus] = useState(false);
	const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
	const [isOpenMeasuringUnitModel, setIsOpenMeasuringUnitModel] = useState(false);
	const [autoFocus, setAutoFocus] = useState({
		catogrey: false,
		product: false,
		shelf: false,
		tax1: false,
	});
	const [projectTitle, setProjectTitle] = useState('Create Product');
	const [error, setError] = useState({});
	const [isOpenCatogery, setIsOpenCatogery] = useState(false);
	const [open, setOpen] = useState(false);
	const [isOpenPackagingModel, setIsOpenPackagingModel] = useState(false);
	const [isSheifId, setIsShelfId] = useState(false);
	const HSNData = useSelector((state) => state?.utility?.data?.data);
	const user = useSelector((state) => state?.userInfo?.userInfo?.data);
	const [clone, setClone] = useState(false);
	const [groupOption, setGroupOptions] = useState([]);
	const [catogeryOption, setCatogeryOption] = useState([]);
	const [shelfOption, setShelfOption] = useState([]);
	const [packagingOption, setPackagingOption] = useState([]);
	const [unitOption, setUnitOption] = useState([]);
	const [HSNoption, setHSNoption] = useState([]);
	const [disabled, setDisabled] = useState(productID ? true : false);
	const [openProductCode, setOpenProductCode] = useState(false);
	const [openHSNCode, setOpenHSNCode] = useState(false);
	const [openPacking, setOpenPacking] = useState(false);
	const [openUnit, setOpenUnit] = useState(false);
	const [openShelfID, setOpenShelfID] = useState(false);
	const [buklImport, setIsbuklImport] = useState(false);
	const [productCode, setproductCode] = useState('');
	const [persistGroupName, setPersistGroupName] = useState('');
	const [group, setGroup] = useState('');
	const [persistCatogey, setPersistCatogery] = useState('');
	const [category, setCategory] = useState('');
	const [persistShlef, setPersistShelf] = useState('');
	const [shelf, setShelf] = useState('');
	const [groupCode, setGroupCode] = useState('');
	const [isErrortable, setIsTableError] = useState(false);
	const [pageLoader, setPageLoader] = useState({
		isLoading: false,
		isSave: false,
		isDraft: false,
	});
	const [tableData, setTableData] = useState([]);
	const initialBatchesRef = useRef([]);
	const [productTabelError, setProductTableError] = useState(false);
	const [productData, setProductData] = useState(null);
	const [taxesList, setTaxesList] = useState([]);

	const product_code = () => {
		let status = '';
		if (productID && productID.includes('id')) {
			const params = new URLSearchParams(productID);
			const map = Object.fromEntries(params.entries());
			status = map.status;
		}
		if (!param || status === 'draft') {
			let param = `product_group_id=${group}`;
			product_code_get(param).then((res) => {
				if (res?.success) {
					setproductCode(res?.data);
				}
			});
		}
	};
	useEffect(() => {
		if (group) {
			product_code();
		}
	}, [group]);

	const getProductById = async () => {
		if (productID && !isNaN(productID)) {
			const product_details = await getProductDetails(productID);
			setProductData(product_details);
			setProjectTitle('Product Details');
		} else if (productID && productID.includes('id')) {
			const params = new URLSearchParams(productID);
			const map = Object.fromEntries(params.entries());
			const { product_details } = await getDraftProductList(map.id);
			setProductData(product_details);
		}
	};

	useEffect(() => {
		getProductById();
	}, [productID]);

	const navigateRouter = (path) => {
		navigate(path);
	};

	const HandleGroupChange = async (value, code) => {
		setGroup(value);
		setGroupCode(code);
		if (value) {
			delete error?.product_group_id;
		}
		if (code) {
			getProductCode(value);
		}
	};

	async function getProductCode(value) {
		let param = `product_group_id=${value}`;
		var res = await product_code_get(param);
		if (res?.success) {
			setproductCode(res?.data);
			delete error?.product_code;
		}
	}

	const handleCatogery = (value) => {
		setCategory(value);
		if (value) {
			delete error?.category_id;
		}
	};

	const [formData, setFormData] = useState({
		name: '',
		hsn_id: '',
		packaging_id: '',
		contains: '',
		unit_id: '',
		sell_loose: false,
		tax1: null,
		tax2: null,
		purchase_discount: '',
		min_stock: '',
		max_stock: '',
		generic_name: '',
		product_image: null,
	});

	useEffect(() => {
		if (groupCode) {
			getProductCode(group);
		}
	}, [groupCode]);

	useEffect(() => {
		if (productID && productData) {
			let BatchData = [];
			productData?.product_batch?.forEach((ele) => {
				BatchData?.push({
					batch_no: ele?.batch_no ? ele.batch_no.toString() : '',
					product_batch_id: ele?.product_batch_id ? ele.product_batch_id.toString() : '',
					quantity: ele?.quantity !== null && ele?.quantity !== undefined ? ele.quantity.toString() : '0',
					free_quantity: ele?.free_quantity !== null && ele?.free_quantity !== undefined ? ele.free_quantity.toString() : '0',
					mfg_date: ele?.mfg_date !== null && ele?.mfg_date !== undefined ? getDate(ele?.mfg_date, false, false, true) : '',
					expiry_date: ele?.expiry_date !== null && ele?.expiry_date !== undefined ? getDate(ele?.expiry_date, false, false, true) : '',
					mrp: ele?.mrp !== null && ele?.mrp !== undefined ? ele.mrp.toString() : '0',
					trade_rate: ele?.trade_rate !== null && ele?.trade_rate !== undefined ? ele.trade_rate.toString() : '0',
					purchase_rate: ele?.purchase_rate !== null && ele?.purchase_rate !== undefined ? ele.purchase_rate.toString() : '0',
					sale_rate: ele?.sale_rate !== null && ele?.sale_rate !== undefined ? ele.sale_rate.toString() : '0',
					is_active: ele?.is_active !== false,
					tags: ele?.tags || [],
				});
			});
			setFormData({
				name: productData?.product_name || '',
				product_code: productData?.product_code || '',
				hsn_id: productData?.hsn_id || '',
				packaging_id: productData?.packaging_id || '',
				contains:
					productData?.contains !== undefined && productData?.contains !== null
						? productData.contains.toString()
						: '',
				unit_id: productData?.unit_id || '',
				sell_loose: productData?.sell_loose || false,
				tax1: productData?.tax_rate_1_id !== null ? Number(productData?.tax_rate_1_id) : null,
				tax2: productData?.tax_rate_2_id !== null ? Number(productData?.tax_rate_2_id) : null,
				purchase_discount: productData?.purchase_discount || '',
				min_stock: productData?.min_stock || '0',
				max_stock: productData?.max_stock || '0',
				generic_name: productData?.generic_name || '',
				product_image: productData?.image || null,
			});
			setCategory(productData?.category_id || '');
			setGroup(productData?.product_group_id || '');
			setShelf(productData?.shelf_id || '');
			setTableData(BatchData);
			initialBatchesRef.current = JSON.parse(JSON.stringify(BatchData));
			if (productID && !isNaN(productID)) {
				setproductCode(productData?.product_code);
			}
			const newGroup = {
				key: productData?.product_group?.product_group_id,
				value: productData?.product_group?.name,
			};
			setGroupOptions((prevOptions) => {
				const exists = prevOptions.some((item) => item.key === newGroup.key);
				if (!exists) {
					return [...prevOptions, newGroup];
				}
				return prevOptions;
			});
		}
	}, [productData]);

	useEffect(() => {
		groupList();
		catogeryList();
		shelfList();
		dispatch(master_data());
		dispatch(HSN_list());
	}, [disabled]);

	useEffect(() => {
		groupList();
	}, [persistGroupName]);

	useEffect(() => {
		catogeryList();
	}, [persistCatogey]);

	useEffect(() => {
		shelfList();
	}, [persistShlef]);

	const getInventoryPackaging = async () => {
		try {
			const { packages } = await getPackagingGeneral({
				filterBy: 'is_active',
				filterValue: true,
				pageSize: 10000,
				page: 1,
			});
			const data = ObjectCreate({
				data: packages,
				key: 'id',
				value: 'name',
			});
			setPackagingOption(data);
		} catch (error) {
			toast.error(error.message || 'Something went wrong!');
		}
	};
	const getInventoryMeasuringUnit = async () => {
		try {
			const { units } = await getMeasuringUnitGeneral({
				filterBy: 'is_active',
				filterValue: true,
				pageSize: 10000,
				page: 1,
			});

			const data = units?.map((item) => {
				return {
					key: item.id,
					value: item.name,
					short_name: item.short_name,
				};
			});
			setUnitOption(data);
		} catch (error) {
			toast.error(error.message || 'Something went wrong!');
		}
	};

	useEffect(() => {
		getInventoryPackaging();
	}, []);
	useEffect(() => {
		getInventoryMeasuringUnit();
	}, []);

	useEffect(() => {
		const result = ObjectCreate({
			data: HSNData,
			key: 'hsn_id',
			value: 'hsn_code',
		});
		setHSNoption(result);
	}, [HSNData]);

	const handleImageUpload = (imageFile) => {
		const updatedData = { ...formData, product_image: imageFile };
		setFormData(updatedData);
	};

	const handleCheckboxChange = (checked) => {
		const updatedData = { ...formData, sell_loose: checked };
		setFormData(updatedData);
	};

	const handleInputChange = (key, value) => {
		const updatedData = { ...formData, [key]: value };
		setFormData(updatedData);

		if (key === 'contains') {
			if (value && !isNaN(Number(value)) && Number(value) > 0 && !value.endsWith('.')) {
				delete error?.contains;
			}
		} else if (value) {
			delete error?.[key];
		}
	};

	const handleMinAndMaxStock = (key, value) => {
		const updatedData = { ...formData, [key]: value };
		setFormData(updatedData);

		let newError = { ...error };

		if (key === 'min_stock') {
			if (Number(value) > 0 && Number(value) > Number(formData.max_stock)) {
				newError.min_stock = 'Minimum Stock cannot be greater than Maximum Stock.';
			} else {
				delete newError.min_stock;
				delete newError.max_stock;
			}
		} else {
			if (
				Number(formData.min_stock) > 0 &&
				Number(value) >= 0 &&
				Number(value) < Number(formData.min_stock)
			) {
				newError.max_stock = 'Maximum Stock cannot be less than Minimum Stock.';
			} else {
				delete newError.max_stock;
				delete newError.min_stock;
			}
		}
		setError(newError);
	};

	const groupList = async () => {
		let param = {
			page: 1,
			pageSize: 1000,
			filterBy: 'status',
			filterValue: 1,
			isDropdown: true,
		};

		var res = await product_group_list(param);
		if (res?.success) {
			var productData = res?.data?.productGroups;
			const productGroups = productData?.map((product) => {
				return {
					key: product?.product_group_id,
					value: product?.name,
				};
			});
			setGroupOptions((prev) => [...prev, ...productGroups]);
			setPersistGroupName('');
		}
	};

	const shelfList = async () => {
		let param = `page=${1}&pageSize=1000`;
		var res = await shelf_list(param);
		if (res?.success) {
			var shelves = res?.data?.shelves;
			const shelvesData = shelves?.map((shelve) => {
				return {
					key: shelve?.shelf_id,
					value: shelve?.name,
				};
			});

			setShelfOption(shelvesData);
			setPersistShelf('');
		}
	};
	const catogeryList = async () => {
		let param = `page=${1}&pageSize=1000`;
		var res = await product_catogery_list(param);
		if (res?.success) {
			var categoryData = res?.data?.productCategories;
			const categories = categoryData?.map((category) => {
				return {
					key: category?.category_id,
					value: category?.name,
				};
			});
			setCatogeryOption(categories);
			setPersistCatogery('');
		}
	};

	const markAsInactive = () => {
		let productIds = Number(productID);
		let formbody = {
			product_ids: [productIds],
			status: 0,
		};
		change_status(formbody).then((res) => {
			if (res?.success) {
				toast.success(res?.message);
				getProductById();
			} else {
				toast.error(res?.message);
			}
		});
	};
	const markAsactive = () => {
		let productIds = Number(productID);
		let formbody = {
			product_ids: [productIds],
			status: 1,
		};

		change_status(formbody).then((res) => {
			if (res?.success) {
				toast.success(res?.message);
				getProductById();
			} else {
				toast.error(res?.message);
			}
		});
	};
	const cloneProduct = () => {
		setTableData([]);
		setFormData((prev) => ({
			...prev,
			name: '',
			product_code: '',
			packaging_id: formData?.packaging_id,
			contains: formData?.contains,
			unit_id: formData?.unit_id,
			sell_loose: formData?.sell_loose,
			tax1: formData?.tax1,
			tax2: formData?.tax2,
			purchase_discount: formData?.purchase_discount,
			min_stock: '0',
			max_stock: '0',
			hsn_id: formData.hsn_id,
			generic_name: '',
			product_image: null,
		}));
		setClone(true);
		setproductCode('');
		if (group) {
			getProductCode(group);
		}
		setDisabled(false);
	};
	const productAdujustment = () => {
		navigate(
			`/user/${suburl}/inventory-adjustment-crete?prodid=${productID}&prod=${productData?.product_name}`,
		);
	};

	const getTaxesList = async () => {
		try {
			const { tax_rates } = await getTaxRates({
				pageSize: 10000,
				page: 1,
				filterBy: 'is_active',
				filterValue: true,
			});
			const taxes = tax_rates.map((data) => {
				return {
					key: Number(data.tax_rate_id),
					value: `${data.tax_name} ${data.rate_in_percentage}%`,
				};
			});
			setTaxesList(taxes);
		} catch (error) {
			toast.error(error.message || 'Somenthing went wrong!');
		}
	};

	function checkValidation() {
		let newError = { ...error };
		let newErrorCell = [...errorCells];

		if (group === undefined || group === null || !group) {
			newError.product_group_id = 'Please select group from the list';
		} else {
			delete newError.product_group_id;
		}
		if (category === undefined || category === null || !category) {
			newError.category_id = 'Please select category from the list';
		} else {
			delete newError.category_id;
		}

		if (formData.name === undefined || formData.name === null || !formData.name) {
			newError.name = 'Please enter product name in the field';
		} else {
			delete newError.name;
		}

		if (formData.hsn_id === undefined || formData.hsn_id === null || !formData.hsn_id) {
			newError.hsn_id = 'Please select HSN Code from the list';
		} else {
			delete newError.hsn_id;
		}
		if (
			formData.packaging_id === undefined ||
			formData.packaging_id === null ||
			!formData.packaging_id
		) {
			newError.packaging_id = 'Please select packaging from the list';
		} else {
			delete newError.packaging_id;
		}
		if (
			formData.contains === undefined ||
			formData.contains === null ||
			String(formData.contains).trim() === ''
		) {
			newError.contains = 'Please enter contains in the field';
		} else if (
			isNaN(Number(formData.contains)) ||
			String(formData.contains).endsWith('.')
		) {
			newError.contains = 'Please enter a valid number';
		} else if (Number(formData.contains) <= 0) {
			newError.contains = 'Contains must be greater than 0';
		} else {
			delete newError.contains;
		}
		if (formData.unit_id === undefined || formData.unit_id === null || !formData.unit_id) {
			newError.unit_id = 'Please select unit from the list';
		} else {
			delete newError.unit_id;
		}

		if (
			Number(formData.min_stock) > 0 &&
			Number(formData.max_stock) >= 0 &&
			Number(formData.max_stock) < Number(formData.min_stock)
		) {
			newError.max_stock = 'Maximum Stock cannot be less than Minimum Stock.';
		} else {
			delete newError.max_stock;
		}

		if (tableData.length > 0) {
			let productIndex = tableData.length - 1;
			const lastRow = tableData[productIndex];

			const isLastRowEmpty = [
				lastRow.batch_no,
				lastRow.purchase_rate,
				lastRow.mfg_date,
				lastRow.expiry_date,
				lastRow.mrp,
			].every((val) => val === '' || val === null);

			if (isLastRowEmpty) {
				tableData.pop();
				newErrorCell = newErrorCell.filter((err) => err.index !== productIndex);
				Object.keys(newError).forEach((key) => {
					if (newError[key] !== undefined) {
						delete newError[key];
					}
				});
			} else {
				if (!lastRow.batch_no) {
					newErrorCell.push({ index: productIndex, field: 'batch_no' });
					newError.batch_no = '';
				} else {
					delete newError.batch_no;
				}

				const purRateVal = Number(lastRow.purchase_rate);
				if (
					lastRow.purchase_rate !== '' &&
					lastRow.purchase_rate !== null &&
					lastRow.purchase_rate !== undefined &&
					(isNaN(purRateVal) || purRateVal < 0)
				) {
					newErrorCell.push({ index: productIndex, field: 'purchase_rate' });
					newError.purchase_rate = '';
				} else {
					delete newError.purchase_rate;
				}

				delete newError.mfg_date;
				delete newError.expiry_date;
				newErrorCell = newErrorCell.filter(
					(err) => err.field !== 'mfg_date' && err.field !== 'expiry_date'
				);

				if (!lastRow.mrp || Number(lastRow.mrp) === 0) {
					newErrorCell.push({ index: productIndex, field: 'mrp' });
					newError.mrp = '';
				} else {
					delete newError.mrp;
				}

				if (
					Number(lastRow.sale_rate) > 0 &&
					(Number(lastRow.sale_rate) < Number(lastRow.purchase_rate) ||
						Number(lastRow.sale_rate) > Number(lastRow.mrp))
				) {
					newErrorCell.push({ index: productIndex, field: 'sale_rate' });
					newError.sale_rate = '';
				} else {
					delete newError.sale_rate;
				}
			}
		}

		if (Object.keys(newError).length > 0 || newErrorCell.length > 0) {
			setErrorCells(newErrorCell);
			setError(newError);
			return true;
		} else {
			return false;
		}
	}

	const publishDraftForm = async () => {
		const isErrorShow = checkValidation();
		if (isErrorShow) {
			toast.error('Unable to create or update product');
		} else {
			try {
				setPageLoader((prev) => ({
					...prev,
					isLoading: true,
					isSave: true,
				}));
				const draftFormData = SaveFormData();
				const params = new URLSearchParams(productID);
				const map = Object.fromEntries(params.entries());
				const res = await publishDraftProduct(map.id, draftFormData);
				if (res.success) {
					toast.success(res?.message);
					getProductById();
					setDisabled(true);
					setPageLoader((prev) => ({
						...prev,
						isLoading: false,
						isSave: false,
					}));
					navigate(`/user/${suburl}/product`);
				} else {
					let errorObj = formatErrors(res?.data?.message);
					setError(errorObj);
					setPageLoader((prev) => ({
						...prev,
						isLoading: false,
						isSave: false,
					}));
					toast.error(res?.response?.data?.message || res?.data?.message);
					if (Array.isArray(res?.response?.data?.message)) {
						setProductTableError(res?.response?.data?.message);
					}
				}
			} catch (error) {
				setPageLoader((prev) => ({
					...prev,
					isLoading: false,
					isDraft: false,
				}));
				toast.error(error.response?.data?.message || 'something went wrong');
				let errorObj = formatErrors(error?.data?.message);
				setError(errorObj);
				setPageLoader((prev) => ({
					...prev,
					isLoading: false,
					isSave: false,
				}));
				toast.error(error?.errorponse?.data?.message || error?.data?.message);
				if (Array.isArray(error?.errorponse?.data?.message)) {
					setProductTableError(error?.response?.data?.message);
				}
			}
		}
	};

	const handleDeleteDraft = async () => {
		try {
			const params = new URLSearchParams(productID);
			const map = Object.fromEntries(params.entries());
			const res = await deleteDraftProduct(map.id);
			if (res.success) {
				toast.success(res.message);
				navigate(`/user/${suburl}/product`);
			} else {
				toast.error(res.message);
			}
		} catch (error) { }
	};

	const submitDraftForm = async () => {
		try {
			setPageLoader((prev) => ({
				...prev,
				isLoading: true,
				isDraft: true,
			}));
			if (productID) {
				const draftFormData = SaveFormData();
				const params = new URLSearchParams(productID);
				const map = Object.fromEntries(params.entries());
				const res = await updateDraftProduct(map.id, draftFormData);
				toast.success(res?.message);
				getProductById();
				setDisabled(true);
				setPageLoader((prev) => ({
					...prev,
					isLoading: false,
					isDraft: false,
				}));
				navigate(`/user/${suburl}/product`);
			} else {
				const draftFormData = SaveFormData();
				const res = await createDraftProduct(draftFormData);
				toast.success(res?.message);
				setIsLocationBlocker(false);
				setIsProductAutoSave(false);
				setPageLoader((prev) => ({
					...prev,
					isLoading: false,
					isDraft: false,
				}));
				setTimeout(() => {
					navigate(`/user/${suburl}/product`);
				}, 300);
			}
		} catch (error) {
			toast.error(error.message || 'Something went wrong!');
		}
	};

	const SaveFormData = () => {
		const draftForm = new FormData();
		for (const key in formData) {
			draftForm.append(key, formData[key]);
		}
		draftForm.append('product_code', productCode?.toString());
		draftForm.append('product_group_id', group?.toString());
		draftForm.append('category_id', category?.toString());
		draftForm.append('shelf_id', shelf?.toString());
		let BatchData = [];
		if (tableData?.length > 0 && tableData?.[0]?.batch_no !== '') {
			tableData?.forEach((ele) => {
				if (productID && clone === false) {
					BatchData?.push({
						product_batch_id: ele?.product_batch_id?.toString(),
						quantity: ele?.quantity || '0',
						free_quantity: ele?.free_quantity?.toString(),
						mfg_date: ele?.mfg_date,
						expiry_date: ele?.expiry_date,
						mrp: ele?.mrp.toString(),
						trade_rate: Number(ele?.trade_rate || 0)?.toString(),
						purchase_rate: ele?.purchase_rate?.toString(),
						sale_rate: Number(ele?.sale_rate || 0)?.toString(),
						batch_no: ele?.batch_no,
					});
				} else {
					BatchData?.push({
						quantity: ele?.quantity || '0',
						free_quantity: ele?.free_quantity?.toString(),
						mfg_date: ele?.mfg_date,
						expiry_date: ele?.expiry_date,
						mrp: ele?.mrp?.toString(),
						trade_rate: Number(ele?.trade_rate || 0)?.toString(),
						purchase_rate: ele?.purchase_rate?.toString(),
						sale_rate: Number(ele?.sale_rate || 0)?.toString(),
						batch_no: ele?.batch_no,
					});
				}
			});
		}
		draftForm.append('product_batch', JSON.stringify(BatchData));
		return draftForm;
	};

	const cleanDate = (d) => {
		if (!d || d === 'MM/YY' || d === 'N/A' || String(d).trim() === '') return null;
		return String(d).trim();
	};

	const formatBatchPayload = (row, isUpdate = false) => {
		const payload = {
			batch_no: row.batch_no,
			quantity: Number(row.quantity || 0),
			free_quantity: Number(row.free_quantity || 0),
			mfg_date: cleanDate(row.mfg_date),
			expiry_date: cleanDate(row.expiry_date),
			mrp: Number(row.mrp || 0),
			trade_rate: Number(row.trade_rate || 0),
			purchase_rate: Number(row.purchase_rate || 0),
			sale_rate: Number(row.sale_rate || 0),
		};
		if (isUpdate) {
			payload.product_batch_id = Number(row.product_batch_id);
		}
		return payload;
	};

	const getBatchesDiff = () => {
		const newBatches = [];
		const updatedBatches = [];

		const initialMap = new Map(
			(initialBatchesRef.current || []).map((item) => [String(item.product_batch_id), item])
		);

		const currentBatchIds = new Set(
			tableData
				?.map((row) => row.product_batch_id && String(row.product_batch_id))
				.filter(Boolean)
		);

		const deletedBatchIds = (initialBatchesRef.current || [])
			.filter(
				(item) =>
					item.product_batch_id &&
					!currentBatchIds.has(String(item.product_batch_id))
			)
			.map((item) => Number(item.product_batch_id));

		tableData?.forEach((row) => {
			if (!row.batch_no || String(row.batch_no).trim() === '') return;

			if (!row.product_batch_id) {
				newBatches.push(formatBatchPayload(row, false));
			} else {
				const initialRow = initialMap.get(String(row.product_batch_id));
				if (initialRow) {
					const isChanged =
						String(row.batch_no || '').trim() !== String(initialRow.batch_no || '').trim() ||
						Number(row.quantity || 0) !== Number(initialRow.quantity || 0) ||
						Number(row.free_quantity || 0) !== Number(initialRow.free_quantity || 0) ||
						cleanDate(row.mfg_date) !== cleanDate(initialRow.mfg_date) ||
						cleanDate(row.expiry_date) !== cleanDate(initialRow.expiry_date) ||
						Number(row.mrp || 0) !== Number(initialRow.mrp || 0) ||
						Number(row.trade_rate || 0) !== Number(initialRow.trade_rate || 0) ||
						Number(row.purchase_rate || 0) !== Number(initialRow.purchase_rate || 0) ||
						Number(row.sale_rate || 0) !== Number(initialRow.sale_rate || 0);

					if (isChanged) {
						updatedBatches.push(formatBatchPayload(row, true));
					}
				}
			}
		});

		return { newBatches, updatedBatches, deletedBatchIds };
	};

	const SubmitForm = () => {
		const isErrorShow = checkValidation();
		if (isErrorShow) {
			toast.error('Unable to create or update product');
		} else {
			const dataToSubmit = new FormData();
			for (const key in formData) {
				dataToSubmit.append(key, formData[key]);
			}
			if (!productID || clone) {
				dataToSubmit.set('product_code', productCode?.toString());
			}
			dataToSubmit.append('product_group_id', group?.toString());
			dataToSubmit.append('category_id', category?.toString());
			dataToSubmit.append('shelf_id', shelf?.toString());

			if (productID && clone === false) {
				setPageLoader((prev) => ({
					...prev,
					isLoading: true,
					isSave: true,
				}));

				const { newBatches, updatedBatches, deletedBatchIds } = getBatchesDiff();
				const apiCalls = [dispatch(product_Update(productID, dataToSubmit))];

				if (updatedBatches.length > 0) {
					apiCalls.push(
						dispatch(
							updateProductBatch({
								product_id: Number(productID),
								product_batches: updatedBatches,
							})
						)
					);
				}

				if (newBatches.length > 0) {
					apiCalls.push(
						dispatch(
							createProductBatch({
								product_id: Number(productID),
								product_batches: newBatches,
							})
						)
					);
				}

				if (deletedBatchIds.length > 0) {
					apiCalls.push(deleteBatch({ batch_ids: deletedBatchIds }));
				}

				Promise.all(apiCalls)
					.then(async (results) => {
						const mainRes = results[0];
						const batchErrorRes = results.slice(1).find((res) => res && res.success === false);

						if (mainRes?.success && !batchErrorRes) {
							toast.success(mainRes?.message || 'Product updated successfully!');
							await getProductById();
							setDisabled(true);
							setTimeout(() => {
								setPageLoader((prev) => ({
									...prev,
									isLoading: false,
									isSave: false,
								}));
							}, 100);
						} else {
							const errorRes = batchErrorRes || mainRes;
							let errorObj = formatErrors(errorRes?.data?.message);
							setError(errorObj);
							setPageLoader((prev) => ({
								...prev,
								isLoading: false,
								isSave: false,
							}));
							toast.error(errorRes?.response?.data?.message || errorRes?.data?.message || errorRes?.message || 'Failed to update product details');
							if (Array.isArray(errorRes?.response?.data?.message)) {
								setProductTableError(errorRes?.response?.data?.message);
							}
						}
					})
					.catch((err) => {
						setPageLoader((prev) => ({
							...prev,
							isLoading: false,
							isSave: false,
						}));
						toast.error(err?.response?.data?.message || err?.message || 'Something went wrong!');
					});
			} else {
				let BatchData = [];
				if (tableData?.length > 0 && tableData?.[0]?.batch_no !== '') {
					tableData?.forEach((ele) => {
						BatchData?.push({
							quantity: ele?.quantity || '0',
							free_quantity: ele?.free_quantity?.toString(),
							mfg_date: ele?.mfg_date,
							expiry_date: ele?.expiry_date,
							mrp: ele?.mrp?.toString(),
							trade_rate: Number(ele?.trade_rate || 0)?.toString(),
							purchase_rate: ele?.purchase_rate?.toString(),
							sale_rate: Number(ele?.sale_rate || 0)?.toString(),
							batch_no: ele?.batch_no,
						});
					});
				}
				setPageLoader((prev) => ({
					...prev,
					isLoading: true,
					isSave: true,
				}));
				dataToSubmit.append('product_batch', JSON.stringify(BatchData));
				dispatch(product_create(dataToSubmit)).then((res) => {
					if (res?.success) {
						toast.success(res?.message);
						getProductById();
						setIsLocationBlocker(false);
						setIsProductAutoSave(false);
						setPageLoader((prev) => ({
							...prev,
							isLoading: false,
							isSave: false,
						}));
						setTimeout(() => {
							navigate(`/user/${suburl}/product`);
						}, 300);
					} else {
						setPageLoader((prev) => ({
							...prev,
							isLoading: false,
							isSave: false,
						}));
						let errorObj = formatErrors(res?.data?.message);
						setError(errorObj);
						toast.error(res?.response?.data?.message);
						if (Array.isArray(res?.response?.data?.message)) {
							setProductTableError(res?.response?.data?.message);
						}
					}
				});
			}
		}
	};

	const getEditProduct = async () => {
		if (location.state) {
			const isEdit = location.state.isEdit;
			setDisabled(!isEdit);
		}
	};

	useEffect(() => {
		document.title = `${projectTitle} | Pharmnex`;
	}, [projectTitle]);

	useEffect(() => {
		getTaxesList();
	}, []);

	useEffect(() => {
		if (location.state) {
			getEditProduct();
		}
	}, [location]);

	useBlocker((tx) => {
		if (!productID && isLocationBlocker) {
			setIsNextLocation(tx);
			setIsProductAutoSave(true);
			return true;
		}
		return false;
	});

	return (
		<>
			<div className="">
				<div className="header-position-sticky">
					{productID ? (
						<div className="product-pg-header add-product">
							<p> {clone ? 'Add New Product' : 'Product Details'}</p>
							<div className="add-product-button">
								{disabled === true && (
									<Button
										type="button"
										className="btn-gray mt-0 px-4"
										button="Edit"
										disabled={
											!hasPermission('inventory.products.edit', user?.role?.role_permissions)
										}
										onClick={() => {
											setDisabled(false);
											setProjectTitle('Update Product');
										}}
									/>
								)}
								{disabled === true && productID && productID.includes('id') && (
									<Button
										type="button"
										className="btn-gray mt-0 px-4"
										button="Delete"
										disabled={
											!hasPermission('inventory.products.edit', user?.role?.role_permissions)
										}
										onClick={() => {
											setIsDeleteModalOpen(true);
										}}
									/>
								)}
								{clone === false && !isNaN(productID) && (
									<Button
										type="button"
										className="btn-gray mt-0 px-4  "
										button="Adjust"
										onClick={productAdujustment}
									/>
								)}
								{clone === false && !isNaN(productID) && (
									<Button
										type="button"
										disabled={
											!hasPermission('inventory.products.clone', user?.role?.role_permissions)
										}
										className="btn-gray mt-0 px-4"
										button="Clone"
										onClick={cloneProduct}
									/>
								)}
								{productData?.status === 0
									? clone === false &&
									!isNaN(productID) && (
										<Button
											type="button"
											disabled={
												!hasPermission('inventory.products.edit', user?.role?.role_permissions)
											}
											className="btn-gray mt-0 px-4  "
											button="Mark as Active"
											onClick={markAsactive}
										/>
									)
									: clone === false &&
									!isNaN(productID) && (
										<Button
											type="button"
											disabled={
												!hasPermission('inventory.products.edit', user?.role?.role_permissions)
											}
											className="btn-gray mt-0 px-4  "
											button="Mark as Inactive"
											onClick={markAsInactive}
										/>
									)}
								{disabled === false && clone === false && !isNaN(productID) && (
									<Button
										type="button"
										className="btn-gray mt-0 px-4"
										button="Batch bulk upload "
										onClick={() => setIsbuklImport(true)}
									/>
								)}
								{disabled === false && (
									<Button
										type="button"
										className="btn-primary mt-0 px-4"
										button={!isNaN(productID) ? 'Save' : 'Publish'}
										disabled={
											productID
												? !hasPermission('inventory.products.edit', user?.role.role_permissions)
												: !hasPermission('inventory.products.create', user?.role.role_permissions)
										}
										onClick={() => {
											setIsProductAutoSave(false);
											if (!isNaN(productID)) {
												SubmitForm();
											} else {
												publishDraftForm();
											}
										}}
										loader={pageLoader.isLoading && pageLoader.isSave}
									/>
								)}
								{disabled === false && isNaN(productID) && (
									<Button
										type="button"
										className="btn-primary mt-0 px-4"
										button="Save As Draft"
										disabled={
											pageLoader.isLoading && pageLoader.isDraft
												? true
												: productID
													? !hasPermission('inventory.products.edit', user?.role.role_permissions)
													: !hasPermission('inventory.products.create', user?.role.role_permissions)
										}
										onClick={() => {
											setIsProductAutoSave(false);
											submitDraftForm();
										}}
										loader={pageLoader.isLoading && pageLoader.isDraft}
									/>
								)}
								<Button
									type="button"
									className="mt-0 btn-danger add-pro"
									button=""
									close
									// onClick={() => navigateRouter(`/user/${suburl}/product`)}
									onClick={() => navigateRouter(-1)}
								/>
							</div>
						</div>
					) : (
						<div className="product-pg-header add-product">
							<p>Add New Product</p>
							<div className="add-product-button">
								<Button
									type="button"
									className="btn-primary mt-0 px-4"
									disabled={
										pageLoader.isLoading && pageLoader.isDraft
											? true
											: !hasPermission('inventory.products.create', user?.role?.role_permissions)
									}
									button="Save"
									loader={pageLoader.isLoading && pageLoader.isSave}
									onClick={SubmitForm}
								/>
								<Button
									type="button"
									className="btn-primary mt-0 px-4"
									disabled={
										pageLoader.isLoading && pageLoader.isDraft
											? true
											: !hasPermission('inventory.products.create', user?.role?.role_permissions)
									}
									button=" Save As Draft"
									loader={pageLoader.isLoading && pageLoader.isDraft}
									onClick={submitDraftForm}
								/>
								{/* <Button type="button" className="btn-dark add-pro" button="Cancel" /> */}
								<Button
									type="button"
									className="mt-0 btn-danger add-pro"
									button=""
									close
									onClick={() => navigateRouter(`/user/${suburl}/product`)}
								/>
							</div>
						</div>
					)}
				</div>
				{/*  product Form */}
				<div className="max-w-1297 px-3 py-2">
					<div className="row">
						<div className="col-5 mt-4">
							<InputSelect
								options={groupOption || []}
								placeholder="Select Group"
								label="Select Group"
								onChange={(value) => {
									HandleGroupChange(value, '');
									getProductCode(value);
								}}
								value={group}
								onAddNew={
									hasPermission('inventory.groups.create', user?.role?.role_permissions)
										? () => setOpen(true)
										: ''
								}
								disabled={disabled}
								required={true}
								error={error?.product_group_id}
								autoFocus={!param?.id || disabled === false ? true : false}
							/>
						</div>
						<div className="col-5 mt-4">
							<InputSelect
								label="Select Category"
								placeholder="Select Category"
								onChange={(value) => handleCatogery(value)}
								value={category}
								options={catogeryOption || []}
								onAddNew={() => setIsOpenCatogery(true)}
								disabled={disabled}
								required={true}
								error={error?.category_id}
								autoFocus={!param?.id || disabled === false ? autoFocus?.catogrey : false}
							/>
						</div>
						<div className="col">
							<ImageUpload
								imageUrl={formData.product_image}
								onImageUpload={handleImageUpload}
								error={error?.image}
								disabled={disabled}
							/>
						</div>
					</div>
					<div className="row">
						<div className="col">
							<InputField
								label="Product Name"
								placeholder="Product Name"
								type="text"
								required={true}
								value={formData.name}
								onChange={(valueData) => {
									const value = valueData.replace(/[^A-Za-z0-9\s'\/\-.%]/g, '');
									handleInputChange('name', value);
								}}
								disabled={disabled}
								error={error?.name}
								autoFocus={!param?.id || disabled === false ? autoFocus?.product : false}
							/>
						</div>
						<div className="col">
							<InputField
								label="Product Code"
								placeholder="Product Code"
								type="text"
								required={true}
								value={productCode}
								disabled={true}
								rightIcon={{
									src: tooltipIcon,
									alt: 'tooltips',
									onClick: () => setOpenProductCode(true),
								}}
								onClick={() => setOpenProductCode(true)}
								error={error?.product_code}
							/>
						</div>
						<div className="col">
							<InputSelect
								options={HSNoption || []}
								placeholder="Select HSN Code"
								label="HSN code"
								onChange={(value) => handleInputChange('hsn_id', value)}
								value={formData.hsn_id}
								disabled={disabled}
								infoIcon
								required={true}
								error={error?.hsn_id}
								onClick={() => setOpenHSNCode(true)}
							/>
						</div>
					</div>
					<div className="row">
						<div className="col-8">
							<div className="row justify-content-start align-items-start">
								<div className="col-xl-5 col-4">
									<InputSelect
										label="Packing"
										placeholder="Packing"
										onChange={(value) => handleInputChange('packaging_id', value)}
										value={formData.packaging_id}
										options={packagingOption || []}
										infoIcon={true}
										required={true}
										autoFocus={isPackagingFocus}
										disabled={disabled}
										error={error?.packaging_id}
										onAddNew={() => {
											setIsOpenPackagingModel(true);
											setPackagingFocus(false);
										}}
										onClick={() => setOpenPacking(true)}
									/>
								</div>
								<div className="col-2">
									<InputField
										label="Contains"
										placeholder="0"
										type="text"
										onChange={(valueData) => {
											if (!valueData) {
												handleInputChange('contains', '');
												return;
											}
											let value = valueData.replace(/[^0-9.]/g, '');
											if (value.startsWith('.')) {
												value = '0' + value;
											}
											const parts = value.split('.');
											if (parts.length > 2) {
												value = parts[0] + '.' + parts.slice(1).join('');
											}
											if (value.length > 1 && value.startsWith('0') && value[1] !== '.') {
												value = value.replace(/^0+/, '') || '0';
											}
											handleInputChange('contains', value);
										}}
										value={formData.contains}
										disabled={disabled}
										error={error?.contains}
										required={true}
									/>
								</div>
								<div className="col-3">
									<InputSelect
										label="Unit"
										placeholder="Select Unit"
										onChange={(value) => handleInputChange('unit_id', value)}
										value={formData.unit_id}
										options={unitOption || []}
										infoIcon={true}
										required={true}
										autoFocus={isMeasuringUnitFocus}
										disabled={disabled}
										error={error?.unit_id}
										onAddNew={() => {
											setIsOpenMeasuringUnitModel(true);
											setMeasuringUnitFocus(false);
										}}
										onClick={() => setOpenUnit(true)}
									/>
								</div>
								<div
									className="col-xl-2 col-3 align-content-center"
									style={{ marginTop: '33px' }}
								>
									<Checkbox
										label="Sell Loose"
										checked={Boolean(formData.sell_loose)}
										onChange={handleCheckboxChange}
										error={error?.sell_loose}
										disabled={disabled}
									/>
								</div>
							</div>
						</div>
						<div className="col-4">
							<InputSelect
								label="Shelf ID"
								placeholder="Select Shelf ID"
								onChange={(value) => setShelf(value)}
								value={shelf}
								options={shelfOption || []}
								onAddNew={() => setIsShelfId(true)}
								infoIcon={true}
								disabled={disabled}
								error={error?.shelf_id}
								onClick={() => setOpenShelfID(true)}
								autoFocus={!param?.id || disabled === false ? autoFocus?.shelf : false}
							/>
						</div>
					</div>
					<div className="row">
						<div className="col-lg-7 col-9">
							<div className="row">
								<div className="col">
									<InputSelect
										options={taxesList}
										label="Tax1"
										placeholder="Tax1"
										required={false}
										error={error?.tax1}
										value={formData.tax1}
										returnInputValue={false}
										disabled={disabled}
										onChange={(value) => {
											if (value === '') {
												setFormData((prev) => ({
													...prev,
													tax1: '',
												}));
											}
										}}
										onSelect={(option) => {
											setFormData((prev) => ({
												...prev,
												tax1: option.key,
											}));
										}}
										autoFocus={!param?.id || disabled === false ? autoFocus?.tax1 : false}
									// onAddNew={() => setIsAddNewVendorModalOpen(true)}
									// leftIcons={[
									// 	{
									// 		src: OpenPOAlert,
									// 		alt: 'Percentage',
									// 		onClick: () => {},
									// 	},
									// ]}
									/>
								</div>
								<div className="col">
									<InputSelect
										options={taxesList}
										label="Tax2"
										placeholder="Tax2"
										required={false}
										error={error?.tax2}
										value={formData.tax2}
										returnInputValue={false}
										disabled={disabled}
										onChange={(value) => {
											if (value === '') {
												setFormData((prev) => ({
													...prev,
													tax2: '',
												}));
											}
										}}
										onSelect={(option) => {
											setFormData((prev) => ({
												...prev,
												tax2: option.key,
											}));
										}}
										autoFocus={!param?.id || disabled === false ? autoFocus?.tax1 : false}
									// onAddNew={() => setIsAddNewVendorModalOpen(true)}
									// leftIcons={[
									// 	{
									// 		src: OpenPOAlert,
									// 		alt: 'Percentage',
									// 		onClick: () => {},
									// 	},
									// ]}
									/>
								</div>
								<div className="col">
									<InputField
										label="Discount"
										placeholder="0.00"
										type="text"
										onChange={(valueData) => {
											var value = valueData?.replace(/[^0-9.]/g, '');
											handleInputChange('purchase_discount', value);
										}}
										value={formData.purchase_discount}
										disabled={disabled}
										error={error?.purchase_discount}
									/>
								</div>
								<div className="col">
									<InputField
										label="Min Stock"
										placeholder="0"
										type="text"
										onChange={(valueData) => {
											var value = valueData?.replace(/[^0-9.]/g, '');
											handleMinAndMaxStock('min_stock', value);
										}}
										value={formData.min_stock}
										disabled={disabled}
										error={error?.min_stock}
									/>
								</div>
								<div className="col">
									<InputField
										label="Max Stock"
										placeholder="0"
										type="text"
										onChange={(valueData) => {
											var value = valueData?.replace(/[^0-9.]/g, '');
											handleMinAndMaxStock('max_stock', value);
										}}
										value={formData.max_stock}
										disabled={disabled}
										error={error?.max_stock}
									/>
								</div>
							</div>
						</div>
						<div className="col-lg-5 col-3 ">
							<InputField
								label="Generic Name"
								placeholder=""
								type="text"
								onChange={(value) => handleInputChange('generic_name', value)}
								value={formData.generic_name}
								disabled={disabled}
								error={error?.generic_name}
							/>
						</div>
					</div>
				</div>

				{productID && !isNaN(productID) && Boolean(formData?.sell_loose) && (
					<div
						className="max-w-1297 mx-3 p-3 mb-3 d-flex align-items-center gap-2 rounded"
						style={{
							backgroundColor: 'var(--color-banner-info-bg, #eff6ff)',
							border: '1px solid var(--color-banner-info-border, #dbeafe)',
							color: '#1e40af',
							fontSize: '13px',
							lineHeight: '1.5',
						}}
					>
						<i
							className="fa fa-info-circle flex-shrink-0"
							style={{ color: 'var(--color-banner-info-icon, #3b82f6)', fontSize: '16px' }}
						/>
						<span>
							Sell Loose enabled. Purchased strips are converted into the smallest sellable unit. For example, 10 strips with 10 tablets each will add 100 tablets to stock.
						</span>
					</div>
				)}

				<AddProductTable
					className="max-w-1297 px-3"
					tableData={tableData}
					setTableData={setTableData}
					disabled={disabled}
					productTabelError={productTabelError}
					setIsTableError={setIsTableError}
					setErrorCells={setErrorCells}
					errorCells={errorCells}
					productName={formData?.name || productData?.product_name || ''}
				/>

				{openProductCode && (
					<div className="">
						<ModalRight
							show={openProductCode}
							isOpen={openProductCode}
							onClose={() => setOpenProductCode(false)}
							title="Product Code"
							description1="Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since."
							description2="Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,"
							description3="Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,"
							linkTitle="Learn More"
							linkPath1="#"
							linkName1="Lorem Ipsum is simply dummy text of the printing"
							linkPath2="#"
							linkName2="Lorem Ipsum is simply dummy text of the printing"
							linkPath3="#"
							linkName3="Lorem Ipsum is simply dummy text of the printing"
							linkPath4="#"
							linkName4="Lorem Ipsum is simply dummy text of the printing"
							linkPath5="#"
							linkName5="Lorem Ipsum is simply dummy text of the printing"
							linkPath6="#"
							linkName6="Lorem Ipsum is simply dummy text of the printing"
						></ModalRight>
					</div>
				)}
				{openHSNCode && (
					<div className="">
						<ModalRight
							show={openHSNCode}
							isOpen={openHSNCode}
							onClose={() => setOpenHSNCode(false)}
							title="HSN Code"
							description1="Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since."
							description2="Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,"
							description3="Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,"
							linkTitle="Learn More"
							linkPath1="#"
							linkName1="Lorem Ipsum is simply dummy text of the printing"
							linkPath2="#"
							linkName2="Lorem Ipsum is simply dummy text of the printing"
							linkPath3="#"
							linkName3="Lorem Ipsum is simply dummy text of the printing"
							linkPath4="#"
							linkName4="Lorem Ipsum is simply dummy text of the printing"
							linkPath5="#"
							linkName5="Lorem Ipsum is simply dummy text of the printing"
							linkPath6="#"
							linkName6="Lorem Ipsum is simply dummy text of the printing"
						></ModalRight>
					</div>
				)}
				{openPacking && (
					<div className="">
						<ModalRight
							show={openPacking}
							isOpen={openPacking}
							onClose={() => setOpenPacking(false)}
							title="Product Packing"
							description1="Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since."
							description2="Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,"
							description3="Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,"
							linkTitle="Learn More"
							linkPath1="#"
							linkName1="Lorem Ipsum is simply dummy text of the printing"
							linkPath2="#"
							linkName2="Lorem Ipsum is simply dummy text of the printing"
							linkPath3="#"
							linkName3="Lorem Ipsum is simply dummy text of the printing"
							linkPath4="#"
							linkName4="Lorem Ipsum is simply dummy text of the printing"
							linkPath5="#"
							linkName5="Lorem Ipsum is simply dummy text of the printing"
							linkPath6="#"
							linkName6="Lorem Ipsum is simply dummy text of the printing"
						></ModalRight>
					</div>
				)}
				{openUnit && (
					<div className="">
						<ModalRight
							show={openUnit}
							isOpen={openUnit}
							onClose={() => setOpenUnit(false)}
							title="Product Unit"
							description1="Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since."
							description2="Lorem Ipsum is simply dummy text of the printing and
typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,"
							description3="Lorem Ipsum is simply dummy text of the printing and
typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,"
							linkTitle="Learn More"
							linkPath1="#"
							linkName1="Lorem Ipsum is simply dummy text of the printing"
							linkPath2="#"
							linkName2="Lorem Ipsum is simply dummy text of the printing"
							linkPath3="#"
							linkName3="Lorem Ipsum is simply dummy text of the printing"
							linkPath4="#"
							linkName4="Lorem Ipsum is simply dummy text of the printing"
							linkPath5="#"
							linkName5="Lorem Ipsum is simply dummy text of the printing"
							linkPath6="#"
							linkName6="Lorem Ipsum is simply dummy text of the printing"
						></ModalRight>
					</div>
				)}
				{openShelfID && (
					<div className="">
						<ModalRight
							show={openShelfID}
							isOpen={openShelfID}
							onClose={() => setOpenShelfID(false)}
							title="Shelt ID"
							description1="Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since."
							description2="Lorem Ipsum is simply dummy text of the printing and
typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,"
							description3="Lorem Ipsum is simply dummy text of the printing and
typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,"
							linkTitle="Learn More"
							linkPath1="#"
							linkName1="Lorem Ipsum is simply dummy text of the printing"
							linkPath2="#"
							linkName2="Lorem Ipsum is simply dummy text of the printing"
							linkPath3="#"
							linkName3="Lorem Ipsum is simply dummy text of the printing"
							linkPath4="#"
							linkName4="Lorem Ipsum is simply dummy text of the printing"
							linkPath5="#"
							linkName5="Lorem Ipsum is simply dummy text of the printing"
							linkPath6="#"
							linkName6="Lorem Ipsum is simply dummy text of the printing"
						></ModalRight>
					</div>
				)}

				{open && (
					<div>
						<Modal
							className="add-productgroup-modal"
							isOpen={open}
							cancelButton={() => setOpen(false)}
							onClose={() => setOpen(false)}
							title="Add New Group"
						>
							<AddProductGroup
								isOpen={open}
								onCLose={() => setOpen(false)}
								setPersistGroupName={setPersistGroupName}
								setAutoFocus={setAutoFocus}
								reloadTable={groupList}
								openGroupCode={() => {
									setIsOpenGroupCodeModel(true);
								}}
								callBackFunction={HandleGroupChange}
								shouldCallCalback={true}
							/>
						</Modal>
					</div>
				)}
				{isOpenGroupCodeModel && (
					<div>
						<Modal
							className="add-productgroup-modal"
							isOpen={isOpenGroupCodeModel}
							cancelButton={() => {
								setIsOpenGroupCodeModel(false);
							}}
							onClose={() => {
								setIsOpenGroupCodeModel(false);
							}}
							title="Add Group Code"
						>
							<CreateGroupCodeModel
								isOpen={isOpenGroupCodeModel}
								onCLose={() => {
									setIsOpenGroupCodeModel(false);
								}}
								reloadTable={() => {
									groupList();
								}}
								setGroupCode={setGroupCode}
								groupCode={groupCode}
								groupId={group}
							/>
						</Modal>
					</div>
				)}
				{isOpenCatogery && (
					<div>
						<Modal
							className="add-productgroup-modal"
							isOpen={isOpenCatogery}
							cancelButton={() => setIsOpenCatogery(false)}
							onClose={() => setIsOpenCatogery(false)}
							title="Add New Category"
						>
							<ProductCatogery
								isOpen={isOpenCatogery}
								onCLose={() => setIsOpenCatogery(false)}
								reloadTable={catogeryList}
								setAutoFocus={setAutoFocus}
								setPersistCatogery={setPersistCatogery}
								handleCatogery={handleCatogery}
							/>
						</Modal>
					</div>
				)}

				{isSheifId && (
					<div>
						<Modal
							className="add-productgroup-modal"
							isOpen={isSheifId}
							cancelButton={() => setIsShelfId(false)}
							onClose={() => setIsShelfId(false)}
							title="Add New shelf"
						>
							<Addshelf
								isOpen={isSheifId}
								onCLose={() => setIsShelfId(false)}
								reloadTable={shelfList}
								setAutoFocus={setAutoFocus}
								setPersistShelf={setPersistShelf}
								setShelf={setShelf}
							/>
						</Modal>
					</div>
				)}

				{isProductAutoSave && (
					<AutoSaveModal
						isOpenModel={isProductAutoSave}
						setIsOpenModel={setIsProductAutoSave}
						user={user}
						permission={'inventory.products.create'}
						type={'Product'}
						withoutSave={() => {
							setIsLocationBlocker(false);
							setIsProductAutoSave(false);
							setTimeout(() => {
								navigate(isNextLocation.nextLocation?.pathname);
							}, 300);
						}}
						saveAsDraft={() => {
							setIsProductAutoSave(false);
							submitDraftForm();
						}}
						SaveAsContinue={() => {
							setIsProductAutoSave(false);
							SubmitForm();
						}}
					/>
				)}
				{isOpenMeasuringUnitModel && (
					<AddMeasuringUnitModel
						isOpenModel={isOpenMeasuringUnitModel}
						setIsOpenModel={setIsOpenMeasuringUnitModel}
						setMeasuringUnitFocus={setMeasuringUnitFocus}
						setFormData={setFormData}
						setMeasuringUnitOption={setUnitOption}
						getList={getInventoryMeasuringUnit}
					/>
				)}

				{buklImport && (
					<div>
						<Modal
							className="add-productgroup-modal"
							isOpen={buklImport}
							onClose={() => setIsbuklImport(false)}
							title=" Batch bulk Import "
						>
							<BulkImport
								isOpen={buklImport}
								onClose={() => setIsbuklImport(false)}
								type={'batch'}
								reloadTable={getProductById}
								productID={productID}
							/>
						</Modal>
					</div>
				)}

				{isDeleteModalOpen && (
					<DeleteModal
						isDeleteBulkConfirmationModalOpen={isDeleteModalOpen}
						setIsDeleteBulkConfirmationModalOpen={setIsDeleteModalOpen}
						selectedListForDelete={[]}
						handleBulkDelete={handleDeleteDraft}
						deleteLength={1}
						saleTypeName={'Product Draft'}
					/>
				)}

				{isOpenPackagingModel && (
					<AddPackagingModel
						isOpenModal={isOpenPackagingModel}
						setIsOpenModal={setIsOpenPackagingModel}
						getList={getInventoryPackaging}
						setPackagingOption={setPackagingOption}
						setFormData={setFormData}
						setPackagingFocus={setPackagingFocus}
					/>
				)}
			</div>
		</>
	);
};

export default CreateProduct;
